import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import WBTextField from "components/input/WBTextField";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { getCookie, removeCookie, setCookie } from "services/utils/CookieHandler";
import useFetch from "services/hooks/useFetch";
import { ApiUrls } from "services/utils/globalVariables";
import { LoginHeading, LoginLabel } from "components/typography/text";

export default function LoginFormSubmitDetails({ setLoading, code, loginData }) {

    const { ChangeName, JwtLogin } = ApiUrls

    const [{}, fetchChangeName] = useFetch(ChangeName, "post")
    const [{}, fetchJwt] = useFetch(JwtLogin, "post")

    const { handleSubmit, control } = useForm()

    const submitLoginDetail = (data) => {
        setLoading(true)
        const bodyObj = {
            "UserName": loginData,
            "Code": code,
            "DisplayName": `${data.Firstname} ${data.Lastname}`,
            "PortalId": "0",
            "SubmitNameMethod": "DisplayName",
            "FirstName": " ",
            "LastName": " ",
            "IsDynamicPass": true,
            "IsPhoneNumber": "true"
        }
        fetchChangeName(bodyObj, handleSubmitDetail)
    }

    const handleSubmitDetail = (res) => {
        if(res.includes("OK")) {
            fetchJwt({u: loginData, p: `${code}777`}, handleToken)
        }
        setLoading(false)
    }

    const handleToken = (res) => {
        setCookie("loginData", res, 1/24)
        if(getCookie("loginData")) {
            window.location.href = "/"
        }
    }

    return (
        <Stack spacing={2}>
            <LoginHeading>نام و نام خانوادگی خود را وارد نمایید</LoginHeading>
            <Stack
                component="form"
                onSubmit={handleSubmit(submitLoginDetail)}
                spacing={2}
            >
                <Stack spacing={1}>
                    <LoginLabel>نام</LoginLabel>
                    <WBTextField
                        control={control}
                        name="Firstname"
                        defualtValue=""
                        autoComplete="off"
                        isRequired={true} 
                        autoFocus={true}
                        sx={{
                            "& input": {
                                direction: "ltr"
                            }
                        }}                              
                    />
                </Stack>
                <Stack spacing={1}>
                    <LoginLabel>نام خانوادگی</LoginLabel>
                    <WBTextField
                        control={control}
                        name="Lastname"
                        defualtValue=""
                        autoComplete="off"
                        isRequired={true}   
                        sx={{
                            "& input": {
                                direction: "ltr"
                            }
                        }}                            
                    />
                </Stack>
                <Button sx={{display: "none !important"}} id="SubmitUserDetail" type="submit">submitData</Button>
            </Stack>
        </Stack>
    )
}